  <div *ngIf="(currentUser$ | async) as user">
    <div *ngIf="!isInIframe">

      <header role="navigation"><!-- navbar-nav -->

        <nav class="navbar navbar-default navbar-fixed-top bg-inverse navbar-inner">
          <div class="container menuContainer" style="width: 100%">

            <div class="navbar-header">
              <button type="button" class="navbar-toggle collapsed" (click)="isCollapsed = !isCollapsed" aria-expanded="false">
                <span class="sr-only">Toggle navigation</span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
              </button>
              <a class="navbar-brand" routerLink="dashboard">AutoRemind</a>
            </div>

            <div [collapse]="isCollapsed" class="collapse navbar-collapse">
              <ul class="nav navbar-nav">
                <li *ngFor="let route of (routesTop$ | async)" class="nav-item">
                  <top-navigation-two-way-unread-notification
                    *ngIf="route.path === 'two-way'"></top-navigation-two-way-unread-notification>

                  <!--
                     xng-click="navModel.isCollapsed = false"
                  -->
                  <a class="nav-link"
                     [class.two-way-link-with-messages-number]="route.path === 'two-way'"
                     routerLinkActive="topmenu_active"
                     routerLink="{{ route.data.routerLink }}"><i
                    class="glyphicon icon-white {{ route.data.icon }}"></i> {{ route.data.label }}</a>
                </li>
              </ul>


              <ul class="nav navbar-nav user_menu pull-right">
                <li class="divider-vertical hidden-phone hidden-tablet"></li>

                <li dropdown class="dropdown">
                  <a id="profileDropDownButton"
                     dropdownToggle class="dropdown-toggle" role="button" aria-controls="dropdown-basic"><img
                    src="img/user_avatar.png"
                    alt="" class="user_avatar"/>
                    {{ user.userName }} <b class="caret"></b> </a>
                  <ul id="profileDropDownMenu"
                      *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                      aria-labelledby="profileDropDownButton" style="min-height: 270px; width: 160px; z-index: 9999999">
                    <!-- TODO: find a way to dynamically adjust the height -->

                    <li *ngFor="let route of (routesProfile$ | async)"
                        class="nav-item" role="menuitem">
                      <span *ngIf="route.data.onClick === undefined">
                        <a class="nav-link dropdown-item"
                         routerLink="{{ route.data.routerLink }}"><i
                        class="{{ route.data.icon }}"></i> {{ route.data.label }}</a>
                      </span>
                      <span *ngIf="route.data.label === 'Rules' && route.data.onClick !== undefined">
                        <a class="nav-link dropdown-item" href="#"
                              (click)="displayAdaptiveRulesDialog()"><i
                            class="{{ route.data.icon }}"></i> {{ route.data.label }}</a>
                      </span>
                    </li>
                    <li class="dropdown-item"><a class="nav-link dropdown-item"
                                                 href="https://autoremind.com/quicksupport"
                                                 target="_blank"><i
                      class="glyphicon glyphicon-new-window"></i> Screen Share</a></li>

                    <!--li ng-click="openAdaptiveRulesDialog()" style="cursor: pointer;">
                      <a href="#"><i class="glyphicon glyphicon-tasks"></i>
                        Edit Adaptive Rules
                      </a>
                    </li-->

                    <li class="dropdown-item divider"></li>

                    <li class="dropdown-item"><a href (click)="logout()">Log Out</a></li>
                    <li class="dropdown-item divider"></li>
                    <li class="dropdown-item" [hidden]="!((isAdmin$ | async) || (isAuthenticatedFromAdmin$ | async))"
                        style="font-size: 11px; color: #ff5722">(Logged in from Admin)
                    </li>
                    <li class="dropdown-item"
                        [hidden]="!((isAdmin$ | async) || (isAuthenticatedFromAdmin$ | async))"
                        style="font-size: 11px; color: #ff5722">UTC:
                      {{ (clock$ | async) | date:'yyyy-MM-dd HH:mm:ss':'UTC' }}
                    </li>
                    <li
                      [hidden]="!((isAdmin$ | async) || (isAuthenticatedFromAdmin$ | async))"
                      style="font-size: 11px; color: #ff5722"
                      uib-tooltip="Time given in user's timezone. Some timezones have multiple names (e.g. US/Arizona is also America/New_York)">
                      User:
                      {{ (clock$ | async) | amDateFormat: 'YYYY-MM-DD HH:mm:ss'}}
                      <br/>({{ user.userTimeZone }})
                    </li>
                    <li style="font-size: 8px; color: #868686">
                      Backend version: {{ portalVersion$ | async }}</li>
                    <!--li style="font-size: 8px; color: #868686">
                      VS: {{ viewSessionId$ | async }}</li-->
                  </ul>
                </li>

              </ul>
            </div>
          </div>
        </nav>
      </header>
    </div>
  </div>
